<div class="row">
  <!-- Side Menu -->
  <div class="col-lg-1 col-12 px-0">
    <app-uiform-side-menu [uiformId]="uiformId" targetId="jasper">
    </app-uiform-side-menu>
  </div>

  <!-- Main Content -->
  <div class="col-lg-11 col-12 ps-lg-0 my-margin-left">
    <div class="row">
      <div class="col-12">
        <div class="breadcrumb-title border-0 mb-3">
          <div
            class="d-flex justify-content-start align-items-center gap-2 flex-wrap"
          >
            <mat-icon color="primary">summarize</mat-icon>
            <p class="text-break text-wrap mb-0">{{'JASPER_REPORT_GUIDELINES.Jasper_Report'| translate}}</p>
          </div>
        </div>
      </div>

      <!-- Report Card -->
      <div class="col-12 col-auto">
        <div class="card">
          <div class="card-header border-bottom">
            <div
              class="d-flex flex-wrap align-items-center justify-content-between gap-2"
            >
              <h5 class="mb-0">
                {{'JASPER_REPORT_GUIDELINES.Jasper_Report_Format'| translate}}
                <span
                  data-bs-toggle="modal"
                  data-bs-target="#info"
                  class="cursor-pointer ms-2"
                  [matTooltip]="
                    'ALLREMAININGS.Jasper_Report_Format' | translate
                  "
                  matTooltipPosition="above"
                  ><i class="bi bi-info-circle fs-5 text-secondary"></i
                ></span>
              </h5>

              <button
                type="button"
                mat-stroked-button
                color="primary"
                data-bs-toggle="modal"
                data-bs-target="#uploadModal"
              >
                <mat-icon>add</mat-icon>
                <span>{{ "BUTTONS.ADD" | translate }}</span>
              </button>
            </div>
          </div>
          <div class="card-body">
            <div class="table-container">
              <div class="table-responsive table-scrollable">
                <table class="table table-bordered table-hover table-sticky-header">
                  <thead>
                    <tr>
                      <th class="text-center">{{ 'COMMON.SNO' | translate }}</th>
                      <th>{{ 'COMMON.NAME' | translate }}</th>
                      <th>{{ 'COMMON.DESCRIPTION' | translate }}</th>
                      <!-- <th>{{ 'COMMON.DESCRIPTION' | translate }}</th> -->
                      <th>{{'JASPER_REPORT_GUIDELINES.Download_Reports'| translate}}</th>
                      <th>{{ 'COMMON.ACTIONS' | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let e of jasperReports; let i = index">
                      <td class="text-center">{{ i + 1 }}</td>
                      <td>{{ e['name'] }}</td>
                      <td>{{ e['description'] }}</td>
                      <td>
                        <div class="d-flex align-items-center gap-2">
                          <button type="button" mat-stroked-button color="primary" title="Download PDF"
                            (click)="downloadFile(e, 'pdf')">
                            <mat-icon>picture_as_pdf</mat-icon>
                            <small>PDF</small>
                          </button>

                          <button type="button" mat-stroked-button color="primary" title="Download Excel"
                            (click)="downloadFile(e, 'csv')">
                            <mat-icon>table_chart</mat-icon>
                            <small>Excel</small>
                          </button>

                          <button type="button" mat-stroked-button color="primary" title="Download HTML"
                            (click)="downloadFile(e, 'html')">
                            <mat-icon>code</mat-icon>
                            <small>HTML</small>
                          </button>
                        </div>

                      </td>
                      <td>
                        <div class="d-flex align-items-center gap-2">
                          <button mat-stroked-button color="primary" class="icon-center icon-width"
                            data-bs-toggle="modal" data-bs-target="#uploadModal" (click)="getReport(e['id'])"
                            [matTooltip]="'COMMON.EDIT' | translate">
                            <mat-icon>edit</mat-icon>
                          </button>
                          <button mat-stroked-button color="warn" class="icon-center icon-width"
                            (click)="deleteJasper(e['id'])" [matTooltip]="'COMMON.DELETE' | translate">
                            <mat-icon class="icon-compact">delete</mat-icon>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Upload Jasper Report -->
<div class="modal fade" id="uploadModal1" tabindex="-1" aria-labelledby="uploadModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <!-- Header -->
      <div class="modal-header">
        <h5 class="modal-title" id="uploadModalLabel">{{ 'Jasper.model' | translate }}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="resetForm()"></button>
      </div>

      <!-- Body -->
      <div class="modal-body">
        <p *ngIf="form['searchError'] == false && form['searchMessage']">
          <app-ncs-alert [message]="form['searchMessage']" type="success" />
        </p>
        <p *ngIf="form['searchError'] ==  true && form['searchMessage']">
          <app-ncs-alert [message]="form['searchMessage']" type="danger" />
        </p>
        <!-- Report Name -->
        <div class="mb-3 d-flex align-items-center">
          <label for="jasperFileName" class="form-label me-2 mb-0" style="width: 130px;">
            {{ 'Jasper.name' | translate }}
          </label>
          <input type="text" class="form-control form-control-sm" id="jasperFileName"
            [(ngModel)]="jasperform.data['name']" [placeholder]="'Jasper.name.placeholder' | translate" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label for="jasperDescription" class="form-label me-2 mb-0" style="width: 130px;">
            {{ 'Jasper.Description' | translate }}
          </label>
          <input type="text" class="form-control form-control-sm" id="jasperDescription"
            [(ngModel)]="jasperform.data['description']" [placeholder]="'Jasper.jasperDescription' | translate" />
        </div>

        <!-- Jasper File Upload -->
        <div class="mb-3 d-flex align-items-center">
          <label for="jasperFile" class="form-label me-2 mb-0" style="width: 130px;">
            {{ 'Jasper.file.upload' | translate }}
          </label>
          <input type="file" class="form-control form-control-sm" id="jasperFile"
            (change)="onJasperFileSelected($event)" [attr.placeholder]="'Jasper.file.placeholder' | translate" />
        </div>


      </div>

      <!-- Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary btn-sm ml-2" data-bs-dismiss="modal"
          [title]="'COMMON.CLOSE'| translate" (click)="resetForm()">
          <i class="fa fa-window-close"></i> {{ 'COMMON.CLOSE' | translate }}
        </button>

        <button type="button" class="btn btn-sm btn-outline-primary me-1" (click)="uploadJasperReport()">
          <i class="fa fa-upload"></i> {{ 'COMMON.UPLOAD' | translate }}
        </button>
      </div>

    </div>
  </div>
</div>

<!-- Upload Jasper Report -->
<div class="modal fade" id="uploadModal" tabindex="-1" aria-labelledby="uploadModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title" id="uploadModalLabel">{{ 'ALLREMAININGS.JasperTitle' | translate }}</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="resetForm()"></button>
      </div>
      <div class="modal-body compact-inputs dropdown-pd-none">
        <!-- Alerts -->
        <p *ngIf="!jasperform.error && jasperform.message">
          <app-ncs-alert [message]="jasperform.message" type="success"></app-ncs-alert>
        </p>
        <p *ngIf="jasperform.error && jasperform.message">
          <app-ncs-alert [message]="jasperform.message" type="danger"></app-ncs-alert>
        </p>

        <div class="row mb-3">
          <div class="col-sm-3 col-12">
            <label for="jasperFileName" class="form-label fw-medium mb-0" style="width:130px">{{ 'ALLREMAININGS.NameS' |
              translate
              }}</label>
          </div>
          <div class="col-sm-9 col-12">
            <!-- <input type="text" class="form-control form-control-sm" id="jasperFileName"
              [(ngModel)]="jasperform.data['name']" [placeholder]="'Jasper.name.placeholder' | translate" /> -->
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
              <input matInput type="text" id="jasperFileName" [(ngModel)]="jasperform.data['name']"
                [placeholder]="'ALLREMAININGS.Name_placeholder' | translate" />
            </mat-form-field>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-sm-3 col-12">
            <label for="jasperDescription" class="form-label fw-medium mb-0" style="width:130px"> {{
              'ALLREMAININGS.Description' |
              translate }} </label>
          </div>

          <div class="col-sm-9 col-12 textarea-container">
            <!-- <textarea class="form-control form-control-sm" id="jasperDescription"
              [(ngModel)]="jasperform.data['description']" [placeholder]="'Jasper.jasperDescription' | translate"
              rows="3"></textarea> -->
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
              <textarea matInput id="jasperDescription" [(ngModel)]="jasperform.data['description']"
                [placeholder]="'ALLREMAININGS.Description_Place' | translate" rows="3"></textarea>
            </mat-form-field>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-sm-3 col-12">
            <label for="jasperFile" class="form-label fw-medium mb-0" style="width:130px">{{ 'ALLREMAININGS.Upload' |
              translate
              }}</label>
          </div>
          <div class="col-sm-9 col-12">
            <!-- <input type="file" class="form-control form-control-sm" id="jasperFile"
              (change)="onJasperFileSelected($event)" [attr.placeholder]="'Jasper.file.placeholder' | translate" /> -->
            <mat-form-field appearance="outline" class="w-100 small-mat-field" subscriptSizing="dynamic">
              <input matInput type="text" id="jasperFile" class="cursor-pointer" [value]="selectedFile?.name || ''"
                (click)="fileInput.click()" [placeholder]="'ALLREMAININGS.JasperFile' | translate" readonly />
              <!-- Hidden file input -->
              <input type="file" #fileInput style="display: none" (change)="onJasperFileSelected($event)" />
              <!-- Attach pin icon as matSuffix -->
              <mat-icon matSuffix class="icon-compact icon-pd-none" (click)="fileInput.click()" matTooltip="{{'ALLREMAININGS.Attach_File'| translate}}"
                role="button" aria-label="Attach file">
                attach_file
              </mat-icon>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="modal-footer">

        <button type="button" mat-stroked-button color="primary" (click)="uploadJasperReport()"
          [disabled]="!selectedFile">
          <mat-icon>upload</mat-icon>
          <span>{{ 'COMMON.UPLOAD' | translate }}</span>
        </button>
        <button type="button" mat-stroked-button color="warn" data-bs-dismiss="modal" (click)="resetForm()"
          [title]="'COMMON.CLOSE' | translate">
          <mat-icon>close</mat-icon>
          <span>{{ 'COMMON.CLOSE' | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</div>



<!-- Modal -->
<div
  class="modal fade"
  id="info"
  tabindex="-1"
  aria-labelledby="infoLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="h4 modal-title fs-5" id="infoLabel">
          {{ "JASPER_REPORT_GUIDELINES.TITLE" | translate }}
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="guidelines-container">
          <!-- Section 1: DOWNLOAD -->
          <div class="mb-4">
            <h5 class="mb-3">
              <span class="badge bg-secondary rounded-pill me-2">1</span>
              {{ "JASPER_REPORT_GUIDELINES.DOWNLOAD" | translate }}
            </h5>
            <p class="text-secondary ms-4 ps-1">
              {{ "JASPER_REPORT_GUIDELINES.DOWNLOAD_DESCRIPTION" | translate }}
            </p>
          </div>

           <div class="mb-4">
            <h5 class="mb-3">
              <span class="badge bg-secondary rounded-pill me-2">2</span>
              {{ "JASPER_REPORT_GUIDELINES.CREATE_REPORT" | translate }}
            </h5>
            <ul class="list-group list-group-flush bg-transparent ms-4">
              <li class="list-group-item bg-transparent border-0 py-1">
                <span class="text-dark fw-bold">1. </span>
                <!-- <b>{{ "JASPER_REPORT_GUIDELINES.OPEN_REPORT" | translate }}</b> - -->
                <span class="text-secondary">{{
                  "JASPER_REPORT_GUIDELINES.CREATE_NEW" | translate
                }}</span>
              </li>
              <li class="list-group-item bg-transparent border-0 py-1">
                <span class="text-dark fw-bold">2. </span>
                <!-- <b>{{ "JASPER_REPORT_GUIDELINES.COUNT" | translate }}</b> - -->
                <span class="text-secondary">{{
                  "JASPER_REPORT_GUIDELINES.NEW_FILE" | translate
                }}</span>
              </li>
              <li class="list-group-item bg-transparent border-0 py-1">
                <span class="text-dark fw-bold">3. </span>
                <!-- <b>{{ "JASPER_REPORT_GUIDELINES.SELECT_PAGE" | translate }}</b> - -->
                <span class="text-secondary">{{
                  "JASPER_REPORT_GUIDELINES.SELECT_PAGE" | translate
                }}</span>
              </li>
              <li class="list-group-item bg-transparent border-0 py-1">
                <span class="text-dark fw-bold">4. </span>
                <!-- <b>{{ "JASPER_REPORT_GUIDELINES.MAX_MIN" | translate }}</b> - -->
                <span class="text-secondary">{{
                  "JASPER_REPORT_GUIDELINES.NEXT" | translate
                }}</span>
              </li>
              <li class="list-group-item bg-transparent border-0 py-1">
                <span class="text-dark fw-bold">5. </span>
                <!-- <b>{{ "JASPER_REPORT_GUIDELINES.ENTER_REPORT_NAME" | translate }}</b> - -->
                <span class="text-secondary">{{
                  "JASPER_REPORT_GUIDELINES.ENTER_REPORT_NAME" | translate
                }}</span>
              </li>
              <li class="list-group-item bg-transparent border-0 py-1">
                <span class="text-dark fw-bold">6. </span>
                <!-- <b>{{ "JASPER_REPORT_GUIDELINES.FINISH" | translate }}</b> - -->
                <span class="text-secondary">{{
                  "JASPER_REPORT_GUIDELINES.FINISH_REPORT" | translate
                }}</span>
              </li>
            </ul>
          </div>

           <div class="mb-4">
            <h5 class="mb-3">
              <span class="badge bg-secondary rounded-pill me-2">3</span>
              {{ "JASPER_REPORT_GUIDELINES.AGGREGATION_FUNCTIONS" | translate }}
            </h5>
            <ul class="list-group list-group-flush bg-transparent ms-4">
              <li class="list-group-item bg-transparent border-0 py-1">
                <span class="text-dark fw-bold">1. </span>
                <!-- <b>{{ "JASPER_REPORT_GUIDELINES.OPEN_REPORT" | translate }}</b> - -->
                <span class="text-secondary">{{
                  "JASPER_REPORT_GUIDELINES.OPEN_REPORT" | translate
                }}</span>
              </li>
              <li class="list-group-item bg-transparent border-0 py-1">
                <span class="text-dark fw-bold">2. </span>
                <!-- <b>{{ "JASPER_REPORT_GUIDELINES.COUNT" | translate }}</b> - -->
                <span class="text-secondary">{{
                  "JASPER_REPORT_GUIDELINES.COUNT" | translate
                }}</span>
              </li>
              <li class="list-group-item bg-transparent border-0 py-1">
                <span class="text-dark fw-bold">3. </span>
                <!-- <b>{{ "JASPER_REPORT_GUIDELINES.SELECT_PAGE" | translate }}</b> - -->
                <span class="text-secondary">{{
                  "JASPER_REPORT_GUIDELINES.AVERAGE" | translate
                }}</span>
              </li>
              <li class="list-group-item bg-transparent border-0 py-1">
                <span class="text-dark fw-bold">4. </span>
                <!-- <b>{{ "JASPER_REPORT_GUIDELINES.MAX_MIN" | translate }}</b> - -->
                <span class="text-secondary">{{
                  "JASPER_REPORT_GUIDELINES.MAX_MIN" | translate
                }}</span>
              </li>
              <li class="list-group-item bg-transparent border-0 py-1">
                <span class="text-dark fw-bold">5. </span>
                <!-- <b>{{ "JASPER_REPORT_GUIDELINES.ENTER_REPORT_NAME" | translate }}</b> - -->
                <span class="text-secondary">{{
                  "JASPER_REPORT_GUIDELINES.MAX_MIN_DESC" | translate
                }}</span>
              </li>
              <li class="list-group-item bg-transparent border-0 py-1">
                <span class="text-dark fw-bold">6. </span>
                <!-- <b>{{ "JASPER_REPORT_GUIDELINES.FINISH" | translate }}</b> - -->
                <span class="text-secondary">{{
                  "JASPER_REPORT_GUIDELINES.PERCENT_TOTAL" | translate
                }}</span>
              </li>
              <li class="list-group-item bg-transparent border-0 py-1">
                <span class="text-dark fw-bold">7. </span>
                <!-- <b>{{ "JASPER_REPORT_GUIDELINES.FINISH" | translate }}</b> - -->
                <span class="text-secondary">{{
                  "JASPER_REPORT_GUIDELINES.FINISH" | translate
                }}</span>
              </li>
            </ul>
            <div class="mt-4">
              <h5>Important:</h5>
                 <span class="text-secondary">Field Name in Jasper Report must be the         Attribute Code shown in the table below.
                 </span>
            </div>
            <div class="mt-4">
            <h5 class="mb-3">{{ "JASPER_REPORT_GUIDELINES.EXAMPLE_TITLE_JASPER" | translate }}</h5>
            <div class="table-responsive">
              <table class="table table-bordered table-hover bg-white">
                <thead class="table-light">
                  <tr >
                    <th>{{ "JASPER_REPORT_GUIDELINES.NO" | translate }}</th>
                    <th class="">
                      {{ "JASPER_REPORT_GUIDELINES.LABEL" | translate }}
                    </th>
                    <th class="">
                      {{ "JASPER_REPORT_GUIDELINES.CODE" | translate }}
                    </th>
                    <th class="">
                      {{ "JASPER_REPORT_GUIDELINES.TYPE" | translate }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let attr of usecaseAttributes  let i = index">
                     <td>
                       <span class="fw-semibold">{{ i + 1 }}</span>
                      </td>

                      <td>
                         {{ attr.label }}
                      </td>

                      <td>
                         {{ attr.code }}
                      </td>

                      <td class="">
                         {{ attr.type }}
                       </td>
                </tbody>
              </table>
            </div>
           </div>
          </div>

          <div class="mb-4">
            <h5 class="mb-3">
              <span class="badge bg-secondary rounded-pill me-2">4</span>
              {{ "JASPER_REPORT_GUIDELINES.DESIGN_JASPER_REPORT" | translate }}
            </h5>
            <ul class="list-group list-group-flush bg-transparent ms-4">
              <li class="list-group-item bg-transparent border-0 py-1">
                <span class="text-dark fw-bold">1. </span>
                <!-- <b>{{ "JASPER_REPORT_GUIDELINES.OPEN_REPORT" | translate }}</b> - -->
                <span class="text-secondary">{{
                  "JASPER_REPORT_GUIDELINES.BASIC_ELEMENT" | translate
                }}</span>
              </li>
              <li class="list-group-item bg-transparent border-0 py-1">
                <span class="text-dark fw-bold">2. </span>
                <!-- <b>{{ "JASPER_REPORT_GUIDELINES.COUNT" | translate }}</b> - -->
                <span class="text-secondary">{{
                  "JASPER_REPORT_GUIDELINES.TITLE_OR_COLUMN_HEADER" | translate
                }}</span>
              </li>
              <li class="list-group-item bg-transparent border-0 py-1">
                <span class="text-dark fw-bold">3. </span>
                <!-- <b>{{ "JASPER_REPORT_GUIDELINES.SELECT_PAGE" | translate }}</b> - -->
                <span class="text-secondary">{{
                  "JASPER_REPORT_GUIDELINES.DETAIL_SECTION" | translate
                }}</span>
              </li>
              <li class="list-group-item bg-transparent border-0 py-1">
                <span class="text-dark fw-bold">4. </span>
                <!-- <b>{{ "JASPER_REPORT_GUIDELINES.MAX_MIN" | translate }}</b> - -->
                <span class="text-secondary">{{
                  "JASPER_REPORT_GUIDELINES.FIELD_EXPRESSION" | translate
                }}</span>
              </li>
              <li class="list-group-item bg-transparent border-0 py-1">
                <span class="text-dark fw-bold">5. </span>
                <!-- <b>{{ "JASPER_REPORT_GUIDELINES.ENTER_REPORT_NAME" | translate }}</b> - -->
                <span class="text-secondary">{{
                  "JASPER_REPORT_GUIDELINES.ADJUST" | translate
                }}</span>
              </li>
              <li class="list-group-item bg-transparent border-0 py-1">
                <span class="text-dark fw-bold">6. </span>
                <!-- <b>{{ "JASPER_REPORT_GUIDELINES.FINISH" | translate }}</b> - -->
                <span class="text-secondary">{{
                  "JASPER_REPORT_GUIDELINES.ARRANGE" | translate
                }}</span>
              </li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="mb-3">
              <span class="badge bg-secondary rounded-pill me-2">5</span>
              {{ "JASPER_REPORT_GUIDELINES.PREVIEW_REPORT" | translate }}
            </h5>
            <ul class="list-group list-group-flush bg-transparent ms-4">
              <li class="list-group-item bg-transparent border-0 py-1">
                <span class="text-dark fw-bold">1. </span>
                <!-- <b>{{ "JASPER_REPORT_GUIDELINES.OPEN_REPORT" | translate }}</b> - -->
                <span class="text-secondary">{{
                  "JASPER_REPORT_GUIDELINES.CLICK_PREVIEW" | translate
                }}</span>
              </li>
              <li class="list-group-item bg-transparent border-0 py-1">
                <span class="text-dark fw-bold">2. </span>
                <!-- <b>{{ "JASPER_REPORT_GUIDELINES.COUNT" | translate }}</b> - -->
                <span class="text-secondary">{{
                  "JASPER_REPORT_GUIDELINES.VERIFY" | translate
                }}</span>
              </li>
              <li class="list-group-item bg-transparent border-0 py-1">
                <span class="text-dark fw-bold">3. </span>
                <!-- <b>{{ "JASPER_REPORT_GUIDELINES.SELECT_PAGE" | translate }}</b> - -->
                <span class="text-secondary">{{
                  "JASPER_REPORT_GUIDELINES.CHECK" | translate
                }}</span>
              </li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="mb-3">
              <span class="badge bg-secondary rounded-pill me-2">6</span>
              {{ "JASPER_REPORT_GUIDELINES.COMPILE" | translate }}
            </h5>
            <ul class="list-group list-group-flush bg-transparent ms-4">
              <li class="list-group-item bg-transparent border-0 py-1">
                <span class="text-dark fw-bold">1. </span>
                <!-- <b>{{ "JASPER_REPORT_GUIDELINES.OPEN_REPORT" | translate }}</b> - -->
                <span class="text-secondary">{{
                  "JASPER_REPORT_GUIDELINES.JRXML" | translate
                }}</span>
              </li>
              <li class="list-group-item bg-transparent border-0 py-1">
                <span class="text-dark fw-bold">2. </span>
                <!-- <b>{{ "JASPER_REPORT_GUIDELINES.COUNT" | translate }}</b> - -->
                <span class="text-secondary">{{
                  "JASPER_REPORT_GUIDELINES.PROJECTOR_EXPLORE" | translate
                }}</span>
              </li>
              <li class="list-group-item bg-transparent border-0 py-1">
                <span class="text-dark fw-bold">3. </span>
                <!-- <b>{{ "JASPER_REPORT_GUIDELINES.SELECT_PAGE" | translate }}</b> - -->
                <span class="text-secondary">{{
                  "JASPER_REPORT_GUIDELINES.COMPILE_JRXMLREPORT" | translate
                }}</span>
              </li>
              <li class="list-group-item bg-transparent border-0 py-1">
                <span class="text-dark fw-bold">4. </span>
                <!-- <b>{{ "JASPER_REPORT_GUIDELINES.MAX_MIN" | translate }}</b> - -->
                <span class="text-secondary">{{
                  "JASPER_REPORT_GUIDELINES.JASPER_STUDIO" | translate
                }}</span>
              </li>
            </ul>
          </div>

            <div class="mb-4">
            <h5 class="mb-3">
              <span class="badge bg-secondary rounded-pill me-2">7</span>
              {{ "JASPER_REPORT_GUIDELINES.UPLOAD" | translate }}
            </h5>
            <ul class="list-group list-group-flush bg-transparent ms-4">
              <li class="list-group-item bg-transparent border-0 py-1">
                <span class="text-dark fw-bold">1. </span>
                <!-- <b>{{ "JASPER_REPORT_GUIDELINES.OPEN_REPORT" | translate }}</b> - -->
                <span class="text-secondary">{{
                  "JASPER_REPORT_GUIDELINES.JASPER_REPORT_SECTION" | translate
                }}</span>
              </li>
              <li class="list-group-item bg-transparent border-0 py-1">
                <span class="text-dark fw-bold">2. </span>
                <!-- <b>{{ "JASPER_REPORT_GUIDELINES.COUNT" | translate }}</b> - -->
                <span class="text-secondary">{{
                  "JASPER_REPORT_GUIDELINES.ADD_JASPER_REPORT" | translate
                }}</span>
              </li>
              <li class="list-group-item bg-transparent border-0 py-1">
                <span class="text-dark fw-bold">3. </span>
                <!-- <b>{{ "JASPER_REPORT_GUIDELINES.SELECT_PAGE" | translate }}</b> - -->
                <span class="text-secondary">{{
                  "JASPER_REPORT_GUIDELINES.ENTER_JASPER_REPORT_NAME" | translate
                }}</span>
              </li>
              <li class="list-group-item bg-transparent border-0 py-1">
                <span class="text-dark fw-bold">4. </span>
                <!-- <b>{{ "JASPER_REPORT_GUIDELINES.MAX_MIN" | translate }}</b> - -->
                <span class="text-secondary">{{
                  "JASPER_REPORT_GUIDELINES.ENTER_JASPER_REPORT_DES" | translate
                }}</span>
              </li>
              <li class="list-group-item bg-transparent border-0 py-1">
                <span class="text-dark fw-bold">5. </span>
                <!-- <b>{{ "JASPER_REPORT_GUIDELINES.ENTER_REPORT_NAME" | translate }}</b> - -->
                <span class="text-secondary">{{
                  "JASPER_REPORT_GUIDELINES.JASPER_FILE" | translate
                      }}</span>
              </li>
              <li class="list-group-item bg-transparent border-0 py-1">
                <span class="text-dark fw-bold">6. </span>
                <!-- <b>{{ "JASPER_REPORT_GUIDELINES.FINISH" | translate }}</b> - -->
                <span class="text-secondary">{{
                  "JASPER_REPORT_GUIDELINES.CLICK_SAVE" | translate
                      }}</span>
              </li>
              <li class="list-group-item bg-transparent border-0 py-1">
                <span class="text-dark fw-bold">7. </span>
                <!-- <b>{{ "JASPER_REPORT_GUIDELINES.FINISH" | translate }}</b> - -->
                <span class="text-secondary">{{
                  "JASPER_REPORT_GUIDELINES.DOWNLOAD_JASPER" | translate
                      }}</span>
              </li>
            </ul>
            </div>

          <!-- Section 4: COMPILE_REPORT -->
          <!-- <div class="mb-4">
            <h5 class="mb-2">
              <span class="badge bg-secondary rounded-pill me-2">5</span>
              {{ "JASPER_REPORT_GUIDELINES.COMPILE_REPORT" | translate }}
            </h5>
            <p class="text-secondary ms-4 ps-1">
              {{
                "JASPER_REPORT_GUIDELINES.COMPILE_REPORT_DESCRIPTION"
                  | translate
              }}
            </p>
          </div> -->
        </div>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer">
        <button
          type="button"
          mat-stroked-button
          color="warn"
          data-bs-dismiss="modal"
          [title]="'BUTTONS.CLOSE' | translate"
        >
          <mat-icon>close</mat-icon>
          {{ "COMMON.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
